import { Button, Typography } from "@repo/design-system";

interface ISelectedMoleculesBarProps {
  count: number;
  isDownloading: boolean;
  downloadProgress: number | null;
  onClearAll: () => void;
  onDownload: () => void;
}

export function SelectedMoleculesBar({
  count,
  isDownloading,
  downloadProgress,
  onClearAll,
  onDownload,
}: ISelectedMoleculesBarProps) {
  if (count === 0) return null;

  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-2 rounded-lg border border-borderPrimary bg-backgroundSecondary px-3 py-2">
      <Typography
        variant="paragraph-m-semibold"
        className="whitespace-nowrap text-contentSecondary">
        Selected molecules · {count}
      </Typography>

      <div className="ms-auto flex flex-wrap items-center justify-end gap-2">
        <Button variant="transparent" size="small" onPress={onClearAll}>
          Clear All
        </Button>
        <Button
          variant="secondary"
          size="small"
          leftIcon={isDownloading ? undefined : "download"}
          loading={isDownloading}
          isDisabled={isDownloading}
          onPress={onDownload}>
          {isDownloading
            ? downloadProgress !== null
              ? `${downloadProgress}% downloaded`
              : "Downloading…"
            : "Download selected"}
        </Button>
      </div>
    </div>
  );
}
